var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('review-list',{key:this.profile.occupation_id,attrs:{"occupation_id":this.profile.occupation_id,"service_providers_id":this.profile.service_provider.id,"occupation_name":this.profile.occupationName,"isMainHeader":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }